import React, { useCallback, useContext } from 'react'
import { NotificationContext } from '../NotificationIO'
import { useNavigate } from 'react-router-dom'
import { usePermission } from '@/hooks'
import routes, { getMenuItems, RouteConfig } from '@/router/routes'
import { Stack } from '@mui/material'
import { SubMenu, Tag, ScrollY } from './components'
import MenuItem from './item'
import Text from '@/components/Text'

export interface MenuProps {
  root: string;
  path: string;
}

const showItem = (userpermissions: string[], needPermissions: string[]) => {
  for (const permission of userpermissions) {
    if (needPermissions?.indexOf(permission) > -1) {
      return true
    }
  }
  if (!needPermissions) {
    return true
  }
  return false
}

const getSubMenuHeight = (
  menuItemHeight: number, // 46
  totalItems: number,
  gap: number // 12
) => {
  return (menuItemHeight + gap) * totalItems - gap
}

const Menu: React.FC<MenuProps> = (props) => {
  const { root, path } = props
  const navigate = useNavigate()
  const { notificatioinData } = useContext(NotificationContext)
  const currentRoutes = getMenuItems(root, routes)
  const perms = usePermission()

  const handleClickMenu = useCallback(
    (path: string) => () => {
      navigate(path)
    },
    [navigate]
  )

  const isSelected = useCallback(
    (item: RouteConfig) => {
      return (
        // @ts-ignore
        (path === item.path || location.pathname?.includes(item?.path)) &&
        !(
          Array.isArray(item?.children) &&
          item?.children?.filter((item) => !item.hideMenu)?.length > 0
        )
      )
    },
    [path]
  )
  const expandable = useCallback((item: RouteConfig) => {
    return (
      Array.isArray(item?.children) &&
      item?.children.filter((child) => !child?.hideMenu)?.length > 0
    )
  }, [])

  const isExpanded = useCallback(
    (item: RouteConfig) => {
      // @ts-ignore
      return expandable(item) && location.pathname.includes(item.path)
    },
    [expandable]
  )
  return (
    <>
      <Text
        key={'ment-title'}
        sx={{
          width: '212px',
          textAlign: 'center',
          display: 'flex',
          alignItems: 'center',
        }}
        weight='bold'
      >
        <>
          {/*   @ts-ignore */}
          {currentRoutes?.icon()}
          {currentRoutes?.name}
        </>
      </Text>
      <ScrollY>
        <Stack sx={{ gap: '4px' }}>
          {currentRoutes?.children?.map(
            (child, index) =>
              // @ts-ignore
              showItem(perms, child.permissions) &&
              !child?.hideMenu && (
                <React.Fragment key={`menu-item-${index}`}>
                  <MenuItem
                    key={`menu-item-${child.path}`}
                    icon={
                      child?.icon
                        ? isSelected(child)
                          ? child?.icon('hover')
                          : isExpanded(child)
                          ? child?.icon('active')
                          : child?.icon('default')
                        : null
                    }
                    expand={isExpanded(child)}
                    selected={isSelected(child)}
                    expandable={expandable(child)}
                    title={
                      <Text
                        className='menu-title'
                        size='xs'
                        weight='regular'
                        // @ts-ignore
                        sx={{ color: isSelected(child) && '#fff' }}
                      >
                        {child?.name}
                      </Text>
                    }
                    onClick={handleClickMenu(
                      child?.path +
                        // @ts-ignore
                        (child?.children?.filter((item) => !item.hideMenu)
                          ?.length > 0
                          ? `/${child?.children?.[0]?.path}`
                          : '')
                    )}
                  />
                  <SubMenu
                    key={`submenu-${child.path}`}
                    // @ts-ignore
                    expand={location.pathname.includes(child.path)?.toString()}
                    height={getSubMenuHeight(
                      48,
                      child?.children?.filter((child) => !child?.hideMenu)
                        ?.length ?? 0,
                      12
                    )}
                  >
                    {child?.children?.map(
                      (subchild) =>
                        !subchild?.hideMenu && (
                          <MenuItem
                            key={`submenu-item-${subchild.path}`}
                            icon={<div style={{ width: '14px' }} />}
                            selected={
                              path === subchild.path ||
                              // @ts-ignore
                              location.pathname?.includes(subchild?.path)
                            }
                            title={
                              <Text
                                size='xs'
                                weight='regular'
                                sx={{
                                  display: 'flex',
                                  gap: '16px',
                                  alignItems: 'center',
                                  marginLeft: '10px',
                                }}
                              >
                                {subchild?.name}
                                {subchild?.showData &&
                                notificatioinData?.[
                                  subchild.showData as 'total_number'
                                ] &&
                                notificatioinData?.[
                                  subchild.showData as 'total_number'
                                ] > 0 ? (
                                  <Tag
                                    highlight={
                                      path === subchild.path ? 'true' : 'false'
                                    }
                                  >
                                    {notificatioinData?.[
                                      subchild.showData as 'total_number'
                                    ] <= 99
                                      ? notificatioinData?.[
                                          subchild.showData as 'total_number'
                                        ]
                                      : '99+'}
                                  </Tag>
                                ) : null}
                              </Text>
                            }
                            onClick={handleClickMenu(
                              [child?.path, subchild?.path].join('/')
                            )}
                          />
                        )
                    )}
                  </SubMenu>
                </React.Fragment>
              )
          )}
        </Stack>
      </ScrollY>
    </>
  )
}

export default Menu
